export enum AssetPreviewMediaType {
  IMAGE = 'image',
  VIDEO = 'video',
  AUDIO = 'audio',
  APPLICATION_PDF = 'application/pdf',
  IMAGE_TIFF = 'image/tiff',
  IMAGE_PHOTOSHOP = 'image/vnd.adobe.photoshop',
  IMAGE_X_PHOTOSHOP = 'image/x-photoshop',
  APPLICATION_3GPP_PIC = 'application/vnd.3gpp.pic-bw-small',
}

export enum FileExtension {
  PPT = 'ppt',
  PPTX = 'pptx',
  DOC = 'doc',
  DOCX = 'docx',
  PNG = 'png',
  KEYNOTE = 'key',
}
